import { useState,useEffect,useCallback } from "react";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { emailTitle,Configuration } from "../../../constants";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { Card,Container,Button, Modal, ModalFooter, ModalBody, ModalHeader } from "reactstrap";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Table from "../../table/Table";
import { usePagination } from "../../../hooks/usePagination";
import RightIcon from "../../svg/RightIcon";
import LeftIcon from "../../svg/LeftButton";
import FilterIcon from "../../svg/FilterIcon";

const Email = () => {
    const [email, setEmail] = useState([]);
    const navigate = useNavigate();
    const [selectedId,setSelectedId] = useState<string>("");
    const [isDeleteModalOpen,setIsDeleteModalOpen] = useState<boolean>(false);
    const role = useAppSelector((state) => state.role.role);


    const {
      data,
      pageNumber,
      setPageNumber,
      pageSize,
      totalCount,
      setRefresh,
      setSearchQuery,
      searchQuery,
      filterOn,
      setSortBy
  } = usePagination({
      endpoint: `/email`,
      filterOn:'Name',
      enabled:true
  })
  const totalPages = Math.ceil(totalCount / pageSize);

  const handleNext = useCallback(() => {
      setPageNumber((prev) => Math.min(totalPages, prev + 1))
  }, [setPageNumber, totalPages])



  const handlePrev = useCallback(() => {
      setPageNumber((prev) => Math.max(1, prev - 1))
  }, [setPageNumber, totalPages])


    /*useEffect(() => {
        
      const fetchEmail = async() => {
        try{
          const response =  await ApiService.axiosApi('/email',{
            method : 'GET'
          })
          if(response.success){
            setEmail(response.data);
            toast.success(response.message|| " email fetch successfully")
          }else{
                toast.error(response.message || " unable to fetch email")
          }
        }catch(error:any){
          console.log(error);
        }
      }
      fetchEmail();
    },[refresh])*/

    const handleDelete = (id:string) => {
      setSelectedId(id);
      setIsDeleteModalOpen(true);
    }
    const handleUpdate = (id:string) => {
      navigate( `/email-update/${id}`);
    }

    const handleDeleteConfirm = async() => {
      try{
        const response = await ApiService.axiosApi(`/email/${selectedId}`,{
          method : 'DELETE' 
        })
        if(response.success){
          toast.success(response.message || "Email deleted successfully");
          setIsDeleteModalOpen(false);
          setRefresh(prev => !prev)
        }else{
          toast.error(response.message || "unable to delete email");
        }
      }catch(error:any){
        toast.error(error.message || "unable to delete email");
      }
    }

  return (

    <>
     <Breadcrumbs mainTitle={emailTitle} parent={Configuration} />
   <div className="tables">
      <Card>
        <CommonCardHeader title="Email List" headClass="pb-3" />
        <div className="d-flex justify-content-between">
        <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                        <div>
                        <input 
                       type="text" 
                       className="search-input"
                       placeholder="...search"
                       value={searchQuery}
                       onChange={(e)=>{setSearchQuery(e.target.value)
                           setPageNumber(1)
                       }}
                        />
                        </div>
                           <div>
                           <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('Name')}>
                         <FilterIcon/>
                       </button>
                           </div>
                    </div>
          {role === "Administrator" && (
            <div className="d-flex justify-content-end">
              <Button onClick={() => navigate(routes.AddEmail)} color="primary" className="mb-2 mx-2">Add Email</Button>
            </div>
          )}
          </div>
          
          <Table
              data={data}
              columns={[
                {header:"Email",accessor:"email"},
                {header : "Name",accessor:"name"},
              ]}
              buttons={[
                {label:"Edit",onClick:handleUpdate,color:"primary",className:"me-2"},
                {label:"Delete",onClick:handleDelete,color:"danger"}
              ]}
           />
           <div className=" d-flex justify-content-end align-content-center" style={{marginRight:'10px', marginTop:'10px'}}>
                        <p style={{ marginRight: '10px' , marginTop:'8px'}}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                             <LeftIcon className="icon"/>
                        </button>
                        <button
                             className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon"/>
                        </button>
                    </div>
         
      </Card>
      <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
        <ModalHeader>Delete Email</ModalHeader>
        <ModalBody>Are you sure you want to delete this email?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleDeleteConfirm}>Delete</Button>
          <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>   
        </ModalFooter>
      </Modal>
      </div>
    </>
  )
};

export default Email;

